import React, { useEffect, useRef } from 'react';
import { useDispatch } from "react-redux";
import { checklistActions } from "../../../util/store/checklist/reducer";
import { vesselActions } from "../../../util/store/vessel/reducer";
import { IChecklist } from "../../../util/varibles/interface";
import { ChecklistEditProvider } from "./ChecklistEditContext";
import ChecklistDragDrop from "./ChecklistDragDrop";
import LeftControl from "./LeftControl";
import MiddleControl from "./MiddleControl";
import RightControl from "./RightControl";

interface IProps {
    data?: IChecklist

    onSave(data: IChecklist): void

    onClose?(): void
}

const PopupEdit: React.FC<IProps> = ({ data, onSave, onClose }) => {
    const rootRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(vesselActions.getVesselContracts());
        dispatch(checklistActions.getSteps());
    }, [dispatch]);

    return <ChecklistEditProvider data={data || {}} getParentEl={() => rootRef.current}>
        <ChecklistDragDrop>
            <div
                ref={rootRef}
                className="flex gap-[24px] m-[-24px] w-[calc(100%+48px)] h-[calc(100%+48px)] relative overflow-hidden"
            >
                <LeftControl />
                <MiddleControl onSave={onSave} onClose={onClose} />
                <RightControl />
            </div>
        </ChecklistDragDrop>
    </ChecklistEditProvider>;
};

export default PopupEdit;
